module.exports = __webpack_public_path__ + "static/media/section8.0c481878.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/quiz/image/section8.png
// module id = 304
// module chunks = 0